import React from 'react';
import PropTypes from 'prop-types';

const CustomCheckbox = ({
  label,
  type = 'checkbox',
  name, checked = false,
  onChange,
  classname = 'custom-checkbox--control',
}) => (
  <label htmlFor={name} className="custom-checkbox--wrapper">
    <input
      type={type}
      name={name}
      checked={checked}
      onChange={onChange}
      className={classname}
      id={name}
    />
    <span className="custom-checkbox--label">{label}</span>
  </label>
);

CustomCheckbox.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  classname: PropTypes.string,
};

export default CustomCheckbox;
